import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MobileCategory } from './MobileCategory';
import { CategoryLink } from '../form-elements/Link';
import { useOfferCategory } from '../../hooks/useOfferCategory';

export function MobileMenu({
    categories,
    setIsNavSidebarVisible,
    children,
    markenStandort
}) {

    const [activeCategory, setActiveCategory] = useState(null);
    const { hasOfferCategory, offerCategory } = useOfferCategory(categories);

    return (

        <ul style={{paddingLeft:0}}>
            {hasOfferCategory && !activeCategory && (
                <li className="mobile-menu-category" onClick={() => setIsNavSidebarVisible(false)}>
                    <CategoryLink category={offerCategory} className="mobile-menu-category-link">
                        <strong>{offerCategory.title}</strong>
                    </CategoryLink>
                </li>
            )}
            {categories && categories?.length > 0 &&
                categories.filter(category => {
                return !category.subCategories.every(subCategory => {
                    return markenStandort.categoryBlacklist.map(cat => String(cat._id)).includes(String(subCategory._id))
                })
            }).map(category => {
                    return (
                        <MobileCategory
                            key={category._id}
                            category={category}
                            activeCategory={activeCategory}
                            setActiveCategory={setActiveCategory}
                            setIsNavSidebarVisible={setIsNavSidebarVisible}
                        />
                    );
                })
            }
            {!activeCategory && children}
        </ul>
    );
}

MobileMenu.propTypes = {
    categories: PropTypes.array,
    setIsNavSidebarVisible: PropTypes.func,
    children: PropTypes.node,
    markenStandort: PropTypes.object
};
